import { createSelector } from 'reselect';
import metaSelector from 'Selectors/metaSelector';

const topifyPresetsSelector = state => state.topifyPresets;
const userStateSelector = state => state.ustate;
const portalPageSelector = state => state.portalpage;

export default createSelector(
	[metaSelector, topifyPresetsSelector, userStateSelector, portalPageSelector],
	(meta, topifyPresets, ustate, portalpage) => {
		return {
			meta: meta,
			ustate: ustate,
			topifyPresets: topifyPresets,
			portalpage: portalpage
		}
	}
);



// WEBPACK FOOTER //
// ./src/selectors/portalPageSelector.js